import defaultApp from './defaultApp.js';

import QuizSteps from './components/QuizSteps.vue';

const quizApp = {
    ...defaultApp,
    components: {
        ...defaultApp.components,
        QuizSteps,
    },
    data() {
        return {
            ...defaultApp.data(),
            dataQuiz: [],
        };
    },
    methods: {
        ...defaultApp.methods,

        async init() {
            if (this.$el.dataset.quiz) {
                try {
                    this.dataQuiz = JSON.parse(this.$el.dataset.quiz);
                } catch (e) {
                    this.dataQuiz = [];
                }
            }
        },
    },
    mounted() {
        this.init();
    },
};

export default quizApp;
